import { adminServerInstance } from "../axios/instances";
import { DRIVER_PICKUP as type } from "./types";

export function getPickupOrder(params) {   
    return function(dispatch) {
        dispatch({type: type.GET_PICKUP_ORDER})
        return adminServerInstance.get(`/business/getpickuporder`, {
            params: params
        })
        .then(({data}) => {
            dispatch({
                type: type.GET_PICKUP_ORDER_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: type.GET_PICKUP_ORDER_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

export function getOrderByManifestNo(params) {   
    return function(dispatch) {
        dispatch({type: type.GET_ORDER_BY_MANIFEST_NO})
        return adminServerInstance.get(`/business/getordersbymanifestno`, {
            params: params
        })
        .then(({data}) => {
            dispatch({
                type: type.GET_ORDER_BY_MANIFEST_NO_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: type.GET_ORDER_BY_MANIFEST_NO_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

export function getManifestList(params) {   
    return function(dispatch) {
        dispatch({type: type.GET_MANIFEST_LIST})
        return adminServerInstance.get(`/business/getmanifestlist`, {
            params: params
        })
        .then(({data}) => {
            dispatch({
                type: type.GET_MANIFEST_LIST_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: type.GET_MANIFEST_LIST_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

/**
 * @param {Object} params - combined object to send for server processing
 * @param {string} params.order_ids 
 * @param {string} params.creator
 * @param {string} params.partner_id
 * @param {string} params.manifest_no // Optional 
 */
export function createPickupManifest(params) {   
    return function(dispatch) {
        dispatch({type: type.CREATE_PICKUP_MANIFEST})
        return adminServerInstance.post(`/business/createpickupmanifest`, {...params})
        .then(({data}) => {
            dispatch({
                type: type.CREATE_PICKUP_MANIFEST_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: type.CREATE_PICKUP_MANIFEST_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

/**
 * @param {Object} params - combined object to send for server processing
 * @param {Array} params.manifest_lists 
 * @param {string} params.pickup_driver
 */
export function assignManifestToDriver(params) {   
    return function(dispatch) {
        dispatch({type: type.ASSIGN_MANIFEST_TO_DRIVER})
        return adminServerInstance.post(`/business/assignmanifestlisttodriver`, {...params})
        .then(({data}) => {
            dispatch({
                type: type.ASSIGN_MANIFEST_TO_DRIVER_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: type.ASSIGN_MANIFEST_TO_DRIVER_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

export function getPickupPartner() {   
    return function(dispatch) {
        dispatch({type: type.GET_PICKUP_PARTNER})
        return adminServerInstance.get(`/business/getpickuppartner`)
        .then(({data}) => {
            dispatch({
                type: type.GET_PICKUP_PARTNER_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: type.GET_PICKUP_PARTNER_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

export function getPickupWarehouse() {   
    return function(dispatch) {
        dispatch({type: type.GET_PICKUP_WAREHOUSE})
        return adminServerInstance.get(`/business/getpickupwarehouse`)
        .then(({data}) => {
            dispatch({
                type: type.GET_PICKUP_WAREHOUSE_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: type.GET_PICKUP_WAREHOUSE_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}